import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../../contexts/AppContext';
import './ProductGrid.css';

interface ProductGridProps {
    showLimit: number;
    viewGrid: number;
    sortOption: string;
    isLoading: boolean;
}

const ProductGrid: React.FC<ProductGridProps> = ({ showLimit, viewGrid, sortOption, isLoading }) => {
    const { filteredProducts } = useApp();

    // 1. Sort Products
    const sortedProducts = [...filteredProducts].sort((a, b) => {
        const priceA = parseFloat(a.price.replace('₹', '').replace(',', ''));
        const priceB = parseFloat(b.price.replace('₹', '').replace(',', ''));

        if (sortOption === 'price') return priceA - priceB;
        if (sortOption === 'price-desc') return priceB - priceA;
        return 0; // Default sorting
    });

    // 2. Limit Products
    const displayedProducts = sortedProducts.slice(0, showLimit);

    if (isLoading) {
        return (
            <div className="product-status-container">
                <div className="loading-spinner"></div>
            </div>
        );
    }

    if (displayedProducts.length === 0) {
        return (
            <div className="product-status-container">
                <div className="empty-state">
                    <div className="empty-icon-wrapper">
                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="9" cy="21" r="1"></circle>
                            <circle cx="20" cy="21" r="1"></circle>
                            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            <line x1="17" y1="10" x2="17" y2="10" strokeWidth="2"></line>
                        </svg>
                    </div>
                    <h3>No products found</h3>
                    <p>Try adjusting your search or filters to find what you're looking for.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="product-grid-container" style={{ gridTemplateColumns: `repeat(${viewGrid}, 1fr)` }}>
            {displayedProducts.map((product) => (
                <div key={product.id} className="product-card">
                    <div className="product-image-wrapper">
                        <img src={product.image} alt={product.name} />
                    </div>

                    <div className="product-info">
                        <h3 className="product-title">{product.name}</h3>

                        <div className="product-price-row">
                            <span className="current-price">{product.price}</span>
                        </div>
                        <div className="product-actions">
                            <Link to={`/shop/${product.id}`} className="read-more-btn">Read More</Link>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProductGrid;
